import { graphql, useStaticQuery } from 'gatsby';

const useThankyouData = () => {
  const { contentfulPage } = useStaticQuery(graphql`
    query {
      contentfulPage(pageId: { eq: "Enterprise - Thank You" }) {
        title
        heroSection {
          backgroundColor
          componentName
          headline
          desktopImage {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75, width: 1653)
          }
          mobileImage {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          mainCta {
            text
            url
          }
        }
        sections {
          componentName
          title
          headline
          subHeadline
          slug
          mainCta {
            text
            url
          }
          listOfContentWithImages {
            heading
            description {
              childMarkdownRemark {
                html
              }
              description
            }
            image {
              description
              gatsbyImageData(placeholder: BLURRED, width: 500, quality: 75)
            }
            cta {
              text
              url
            }
          }
          embeddedVideoLink
          desktopImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          mobileImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          description {
            childMarkdownRemark {
              html
            }
            description
          }
        }
      }
    }
  `);

  return contentfulPage;
};
export default useThankyouData;
